import axios from 'axios';

export default function getApprovals({ page, length, companyName, regNo, status, plan, expiredSort }) {
  const start = page * length;
  // No expiredSort keeps the server's default order (newest company first).
  const sort = expiredSort ? { column: 'expired_at', order: expiredSort } : {};
  const promise = new Promise((resolve, reject) => axios
    .get('/account/system-admin/api/v1/companies',
      {
        params: {
          start,
          length,
          companyName,
          regNo,
          status,
          plan,
          ...sort,
        },
      })
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message)));

  return promise;
}
